export default __webpack_public_path__ + "static/DA-f647dbef9dd48115d0d352d891840708.png";